import React, { Component, useState } from "react";
import { PhotoIcon, UserCircleIcon } from '@heroicons/react/24/solid'
import { useNavigate, Link } from "react-router-dom";
import store from "@/redux/store";

import {FieldHolder} from "@/components/holders/FieldHolder";

import { useForm, SubmitHandler, Controller } from "react-hook-form"
import  {IUser} from "@/models/User";
import  {IAddress} from "@/models/interfaces";
import { TenantUserFields } from "./TenantUserFields"; 
import { Switch,Label, Field } from '@headlessui/react'

type props = IUser | IAddress



export function Pavillion({...props}) {
    const register = props.register;
    const key = "PAVILLION";
    const [data, setData] = useState(props.userfields[key].data);
function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}
const onChangeField= (name, event) => {
    setData({...data, [name] : event.target.value });
    
    
}

const onChangeAllRightsForChilds= (name, isOn) => {
    //data[key].data[name] = isOn;
    setData({...data, [name] : isOn });
    props.setValue(key, data)
} 
props.setValue(key, data)
/*
  React.useEffect(() => {
      //return;
//      console.log("watch", watch("email"));
//return;      
      if(props.data && watch("key") != props.data.key) {
          reset(props.data);
      } else if(!props.data && formState.defaultValues && formState.defaultValues["id"] && formState.defaultValues["id"] > 0) {
for (const [key, value] of Object.entries(formState.defaultValues)) {
  formState.defaultValues[key] = "";
}          
reset(formState.defaultValues, { keepDirtyValues: true }); 
          //formState.defaultValues = {};
          //reset();
      }
//    if (formState.isSubmitSuccessful) {
      //reset(undefined);
//    }
  }, [formState, reset])
*/
    let addressIndex = 0;
  return (
    <>



       
          <div className="px-4 py-6 sm:p-8">
            <div className="mt-10 space-y-8 pb-12 sm:space-y-0   sm:pb-0">



            <div className="grid grid-cols-12 gap-3">
            
            
              <label htmlFor="mapRights" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                Gebruiker kan reacties plaatsen  
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">

    <Switch
      defaultChecked={ (data?.reactions) ? data?.reactions : false }      
        onChange={(isOn) => {onChangeAllRightsForChilds("reactions", isOn);}}
        //{onChangeAllRightsForChilds(event,event)} 
      className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
    >
      <span className="sr-only">Use setting</span>
      <span
        aria-hidden="true"
        className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
      />
    </Switch>                
              
             
              
              </div>

          
            </div>


            <div className="grid grid-cols-12 gap-3">
            
            
              <label htmlFor="mapRights" className="block text-sm font-medium leading-6 text-gray-900 sm:pt-1.5">
                Gebruiker kan artikelen plaatsen  
              </label>
              <div className="mt-2 sm:col-span-2 sm:mt-0">

    <Switch
      defaultChecked={ (data?.creator) ? data?.creator : false }      
        onChange={(isOn) => {onChangeAllRightsForChilds("creator", isOn);}} 
      className="group relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent bg-gray-200 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-indigo-600 focus:ring-offset-2 data-[checked]:bg-indigo-600"
    >
      <span className="sr-only">Use setting</span>
      <span
        aria-hidden="true"
        className="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out group-data-[checked]:translate-x-5"
      />
    </Switch>                
              
             
              
              </div>

          
            </div>
            <div className="grid grid-cols-12 gap-3">
                <FieldHolder colspan="4" smcolspan="5" label="Alias" id="alias" error={props?.state?.error} >
                      <input
                        id="alias"
                        type="text"
                        defaultValue={data["alias"]}
                        onChange={(event) => {onChangeField("alias", event);}}
                        data-dashlane-disabled-on-field="true"
                        className="component block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      />
                </FieldHolder>
            </div>
</div>
</div>          
    </>
      );
}      